import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import { AccountInfo } from '@azure/msal-common';
import { MsalService } from '@azure/msal-angular';
import { SettingsService } from './settings.service';
import { groups } from '../auth-config';

export interface Account extends AccountInfo {
    idTokenClaims?: {
        roles?: string[],
        groups?: string[],
        _claim_names?: {
            groups: string | string[]
        },
        _claim_sources?: {
            src1: {
                endpoint: string | string[]
            }
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupGuardService implements CanActivate {

    constructor(private authService: MsalService,

        private settingsService: SettingsService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        let account: Account | undefined = this.authService.instance.getActiveAccount() as Account | undefined;
        if (!account) {
            account = this.authService.instance.getAllAccounts()[0] as Account | undefined;
            if (account) {
                this.authService.instance.setActiveAccount(account);
            }
        }

        if (route.params['meetingkey'] !== null && route.params['meetingkey'] !== undefined && route.params['meetingkey'] !== '') {
            localStorage.setItem('meetingKey', route.params['meetingkey']);
        }
        if (route.params['moderatorkey'] !== null && route.params['moderatorkey'] !== undefined && route.params['moderatorkey'] !== '') {
            localStorage.setItem('moderatorKey', route.params['moderatorkey']);
        }

        // MsalGuard handles authentication redirects. If account has not yet been
        // hydrated during app bootstrap, do not block route activation here.
        if (!account) {
            return true;
        }

        //this.settingsService.setIsAdmin(account.idTokenClaims?.groups?.includes(groups.groupAdmin)); // account.idTokenClaims?.roles.indexOf('language.admin') != -1)

        this.settingsService.setIsAdmin(account);

        if (route.data['expectedRole'] === 'admin') {
            if (!this.settingsService.getIsAdmin()) {
                window.alert('You do not have access for this.');
                return false;
            }
        }

        if (this.IsDevEnvironment && account.idTokenClaims?.groups?.includes(groups.groupDevelopers)) {
            return true;
        }

        if (this.IsTestEnvironment && account.idTokenClaims?.groups?.includes(groups.groupTester)) {
            return true;
        }

        if (this.IsProdEnvironment) {
            return true;
        }

        window.alert('You do not have access for this.');
        return false;
    }

    public get IsDevEnvironment(): boolean {
        return window.location.host.startsWith('localhost:4200');
    }

    public get IsTestEnvironment(): boolean {
        return window.location.host.startsWith('wbt.devtest.gf.aws.scania.com');
    }

    public get IsProdEnvironment(): boolean {
        return window.location.host.startsWith('wbd.scania.com')
            || window.location.host.startsWith('wbt.prod.gf.aws.scania.com');
    }
}
